import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// 配置 NProgress
NProgress.configure({ 
  showSpinner: false,  // 不显示加载圆圈
  minimum: 0.1,        // 最小百分比
  easing: 'ease',      // 动画方式
  speed: 500,          // 动画速度
  trickleSpeed: 200    // 递增速度
})

export default NProgress 